import { render, staticRenderFns } from "./progressItemFour.vue?vue&type=template&id=2df3f747&scoped=true"
import script from "./progressItemFour.vue?vue&type=script&lang=js"
export * from "./progressItemFour.vue?vue&type=script&lang=js"
import style0 from "./progressItemFour.vue?vue&type=style&index=0&id=2df3f747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3f747",
  null
  
)

export default component.exports